<template>
	<div class="medical" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="销巴医疗招募" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="banner" :style="paddT">
         		<img src="../../assets/advDetail/medical/top.png" />
         		<img src="../../assets/advDetail/medical/middle.png" />
         		<img src="../../assets/advDetail/medical/bottom.png" />
			</van-col>
			<van-col span="24" class="contact">
				<p class="title"><img src="../../assets/advDetail/medical/zdcx_1.png" /></p>
				<p class="p1">销巴医疗全国战略合作咨询电话</p>
         		<p class="p2"><span>4000571671</span>(<span>转8号线</span>)<span class="last">8</span></p>
         		
         		<p class="p1 p3">负责人(微信同号)</p>
         		<p class="p2"><span>18367326088</span>(<span>曾总</span>)<span class="last">8</span></p>

			</van-col>
			<van-col span="24" class="footer">
				<a class="left" href="tel:4000571671" @click="iOStel()"><img src="../../assets/advDetail/medical/zdcx.png" /></a>
				<a class="right" v-if="isApp == 1" @click="consultation()"><img src="../../assets/advDetail/medical/jmsq.png" /></a>
				<a class="right" v-if="isApp == 0" @click="open_app()" href="ShallBuyLife123://"><img src="../../assets/advDetail/medical/jmsq.png" /></a>
			</van-col>
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	tel: '',
    	isApp: true,
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    consultation() {
	    this.$router.push({
          path: "/advDetail/applyFor",
          query: {
            type: this.$route.query.type
          }
        });
	},
    iOStel() {
		let ua = navigator.userAgent.toLowerCase();
		if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
	        this.phone();
	    }
	},
	phone() {
		this.tel = '4000571671';
		this.params(this.tel, this.tel, 'phone');
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  }
};
</script>

<style lang="less">
.medical {
	background: #C3FADE;
	min-height: 100%;
	padding-bottom: 116px;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.banner{
		width: 100%;
		height: auto;
		img{
			width: 100%;
			display: block;
		}
	}
	.contact{
		text-align: center;
		.title{
			img{
				width: 74.4%;
			}
		}
		.p1{
			color: #86DCB0;
			font-size: 14px;
			height: 20px;
			line-height: 20px;
			margin-top: 8px;
		}
		.p2{
			color: #73C49A;
			font-size: 18px;
			height: 25px;
			line-height: 25px;
			.last{
				color: #C3FADE;
			}
			span{
				border-bottom: solid 1px #73C49A;
			}
		}
		.p3{
			margin: 14px 0 1px;
		}
	}
	.footer{
		width: 100%;
		height: 74px;
		position: fixed;
		bottom: 0;
		left: 0;
		background: url(../../assets/advDetail/medical/bg7.png) no-repeat center center;
		background-size: 100% 100%;
		z-index: 6;
		.left{
			width: 41.9%;
			height: 72px;
			display: inline-block;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 9;
		}
		.right{
			width: 64%;
			height: 72px;
			display: inline-block;
			position: fixed;
			bottom: 0;
			right: 0;
			z-index: 8;
		}
		img{
			display: inline-block;
			width: 100%;
			height: 100%;
		}
	}
	
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
